module.exports = __webpack_public_path__ + "img/icon1.53c9ad4a.png";